module.exports = __webpack_public_path__ + "static/media/bandera-inglesa.eb17ab43.svg";